/******************/
/* DOCUMENT READY */
/******************/
$(document).ready(function(){

    $(document).click(function(event) {
        var targid = event.target.id;
        if (targid == 'setting-gwpfree_amount')
          $('#'+targid).datepicker();
    });


  // Creates container the same height as navigation to ensure smoother scroll when the navigation position is changed to fixed
  var h = $('#shopify-section-header').height();
  $('#shopify-section-header').wrap( "<div class='header_holder'></div>" );
  $('.header_holder').height(h);

  //For nav height for mobile
  if(screen.width < 750 )
  $('.header-navigation nav[role="navigation"]').css({'height':"calc( 84vh - "+$('[data-section-id="header"]').height()+"px)" })

  //For Homepage Slider
  $('img[usemap]').rwdImageMaps();
});


$(window).load(function() {
  //For nav height for mobile
  if(screen.width < 750 )
  $('.header-navigation nav[role="navigation"]').css({'height':"calc( 84vh - "+$('[data-section-id="header"]').height()+"px)" })
})

/*****************/
/* WINDOW SCROLL */
/*****************/
$(window).scroll(function(){
  // HEADER FIXED
  if ($(window).scrollTop() >= 0 ) {
    $('#shopify-section-header').addClass('fixed-header');
    $('#shopify-section-header').addClass('isStuck');
  }
  else {
    $('#shopify-section-header').removeClass('fixed-header');
    $('#shopify-section-header').removeClass('isStuck');
  }

  if(screen.width < 750 )
  $('.header-navigation nav[role="navigation"]').css({'height':"calc( 84vh - "+$('[data-section-id="header"]').height()+"px)" })
});



/*****************/
/* WINDOW RESIZE */
/*****************/
var cartUpdateCalledFromFree = false;

$(window).resize(function() {
  //To ensure smooth scrolling when header is set to position fixed
  var headerHeight = $('#shopify-section-header').height();
  $('.header_holder').height(headerHeight);
});
